import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '@base/src/app/pages/configuration/panel/configuration.component';

@Component({
  selector: 'app-config-delete-user',
  templateUrl: './config-delete-user.component.html',
  styleUrls: ['./config-delete-user.component.scss'],
})
export class ConfigDeleteUserComponent implements OnInit {
  @Input() value!: User;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    if (this.value) this.change.emit('disabled');
  }

  checkDisabled(status: boolean) {
    if (status) this.change.emit(this.value.id);
    if (!status) this.change.emit('disabled');
  }
}
